import { transform } from '../contentTransformer/aemComponentTransformer';
import { TransformedNode } from '../../../../interfaces/src/lib/interfaces/index';

/**
 * AEM page data fetcher
 *
 * Fetches AEM data and always resolves to transformed AEM payload.
 */
async function fetchAemPage(baseUrl: string) {
  if (baseUrl?.includes('/editor.html/')) return null;

  const pathNoQueryString = baseUrl
    .split('?')[0]
    .replace('.html', '')
    .replace(window.location.origin, '');

  try {
    const response = await fetch(
      `${pathNoQueryString}${pathNoQueryString.includes('/') ? '' : '/'}.model.json`
    );
    const data = await response.json();
    return transform(data);
  } catch (err) {
    console.log('ERROR - Fail to fetch content:', err);
    return null;
  }
}

export const fetchAemPageContent = async (path = ''): Promise<TransformedNode | null> => {
  const baseUrl = document.querySelector('meta[name="baseURL"]')?.getAttribute('content') || path;
  return await fetchAemPage(baseUrl);
};

export const fetchRouteAemPageContent = async (path = ''): Promise<TransformedNode | null> => {
  return await fetchAemPage(path);
};
